import { Message } from 'element-ui';
// 定义一个新的Message方法，多传入一个offset参数
let messageInstance = null;

const DonMessage = options => {
  console.log(options);

  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message({
    ...options,
    offset: 96
  });
  return messageInstance;
};
// 重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  DonMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 96
      };
    }
    options.type = type;
    return DonMessage(options);
  };
});
// 将$message挂载到this上

export default DonMessage;



// WEBPACK FOOTER //
// ./src/util/message.js